// 我的
<template>
  <div class="mine">
    <van-nav-bar
      fixed placeholder>
      <template #right>
        <van-icon
          :class="userInfo.unreadMsgCount ? 'point' : ''"
          style="margin-right: 8px;"
          size="24"
          :name="require('@/assets/images/icon/message.png')"
          @click="$router.push('message')"
        />
      </template>
    </van-nav-bar>
    <div class="card">
      <div class="flex-column align-center" style="padding: 0 20px;">
        <div class="avatar">
          <img
          :src="userInfo.headPortrait ? userInfo.headPortrait : require('@/assets/images/login-page/logo.png')"
          @click="$router.push('information')" />
        </div>
        <div class="info flex-column align-center">
          <div>{{ userInfo.name }}</div>
          <span>level: {{ userInfo.grade }}</span>
        </div>
        <!-- <div class="info" @click="$router.push('/login')">{{ $t('login.title') }}</div> -->
      </div>
    </div>
    <div style="margin-top: 30px;">
      <van-cell-group inset>
        <van-cell title="My favorite" value="" is-link to="favorite" :icon="require('@/assets/images/icon/favorite.png')"/>
        <van-cell title="Help" value="" is-link to="help" :icon="require('@/assets/images/icon/help.png')" />
        <van-cell title="Settings" value="" is-link to="setting" :icon="require('@/assets/images/icon/settings.png')" />
        <van-cell title="User manual" value="" is-link to="manual" :icon="require('@/assets/images/icon/manual.png')" />
<!--        <van-cell title="Recovery site" value="" is-link to="sites" :icon="require('@/assets/images/icon/location.png')"/>-->
      </van-cell-group>
    </div>
    <tab-bar />
  </div>
</template>

<script>
import TabBar from '@/components/tab-bar'
export default {
  name: 'Mine',
  components: {
    TabBar
  },
  data () {
    return {
    }
  },
  created() {

    if (navigator.geolocation) {

      navigator.geolocation.getCurrentPosition(
        // navigator.geolocation.watchPosition(
        (position) => {
          console.log(position,"-------====3333333333")
        },
        (e) => {
          console.log(e,"-------====11111111111111222222")
        }
      );
    } else {
      // Browser doesn't support Geolocation
      console.log("Browser doesn't support Geolocation-------====3333333333")
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    }
  },
  methods: {
    // 跳转
    linkTo (row) {
      this.$router.push(row.path)
    }
  }
}
</script>

<style lang="less">
  .mine {
    .point {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        right: -7px;
        top: 0;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background: #E8252A;
      }
    }
    .card {
      position: relative;
      background: #fff;
      padding: 25px 0;
      border-radius: 10px;
      margin-bottom: 15px;
      .avatar {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .info {
        font-family: PingFang SC Regular, PingFang SC Regular-Regular;
        font-size: 30px;
        color: #333;
        span {
          margin-top: 2px;
          font-size: 26px;
          color: #FFCB2E;
        }
      }
    }
    .image, .num {
      margin-bottom: 20px;
    }
    .image {
      width: 48px;
      height: 48px;
    }
    .badge {
      position: absolute;
      top: 8px;
      left: 55%;
      background: rgb(255, 87, 87);
      padding: 2px 6px;
      font-size: 12px;
      min-width: 22px;
      color: #fff;
      border-radius: 16px;
      text-align: center;
    }
    .num {
      font-weight: bold;
      font-family: PingFang SC Heavy, PingFang SC Heavy-Heavy;
      font-size: 50px;
    }
  }
</style>
